
export default class CommonConstants{
    static STUDENT_REF = "111"
    static EMPTY_ANSWER = "?"
    static PROBLEM_COUNT = 30
    
}